import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { UtilService } from '../../services/util.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'fk-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioComponent),
            multi: true,
        },
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule
    ]
})
export class RadioComponent implements ControlValueAccessor {
  @Input()
  public name: string = '';

  @Input()
  public label: string = '';

  @Input()
  public description: string = '';

  @Input()
  public value: any;

  public onChange!: () => {};
  public onTouched!: () => {};

  public radioId: string;

  public formControl = new FormControl();

  constructor() {
    this.radioId = UtilService.getRandId();
  }

  public writeValue(val: any): void {
    this.formControl.setValue(val);
  }
  public registerOnChange(fn: any): void {
    this.formControl.valueChanges.subscribe(fn);
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable();
    } else {
      this.formControl.enable();
    }
  }
}
